import { ILayoutAssignment, LAYOUT_ASSIGNMENTS_SCHEMA } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { ISaveGateway } from '../gateways';

export class SortLayoutAssignmentGateway implements ISaveGateway<
  ILayoutAssignment[],
  IApiResponse<ILayoutAssignment[]>
> {
  private readonly restCallBuilder: RestCallBuilder<ILayoutAssignment[]> =
    new RestCallBuilder<ILayoutAssignment[]>([]);

  save(
    query: ILayoutAssignment[]
  ): Observable<IApiResponse<ILayoutAssignment[]>> {
    return this.restCallBuilder
      .post('/sort-layout-assignments/saveAll', query)
      .validate(
        API_RESPONSE_SCHEMA(LAYOUT_ASSIGNMENTS_SCHEMA),
        'SortLayoutAssignment.saveAll'
      )
      .handleMessages()
      .build();
  }
}
